import React from 'react';
import Popup from 'reactjs-popup';
import { Button, Form } from 'semantic-ui-react'; 
import { SubtitleContext } from '../../contexts/SubtitleContext';
import TranslationsNavbar from '../layout/TranslationsNavbar';
import DragHandleUtils from '../../helper/DragHandleUtils';
import { confirmAlert } from 'react-confirm-alert';
import TimeUtils from '../../helper/TimeUtils';
import DataObj from '../../class/DataObj'; 
import WaveformView from './WaveformView';
import MathUtils from '../../helper/MathUtils';
import FrameUtils from '../../helper/FrameUtils';
 
import ExportView_Popup from '../popup/ExportView_Popup'; 
import Complete_Popup from '../popup/Complete_Popup'; 
import TimecodeShiftView_Popup from '../popup/TimecodeShiftView_Popup';
import RunZerotime_Popup from '../popup/RunZerotime_Popup';
import VersionsView_Popup from '../popup/VersionsView_Popup';
import ShowTimeLineAlert_Popup from '../popup/ShowTimeLineAlert_Popup';
import PositionAlignDialog_Popup from '../popup/PositionAlignDialog_Popup';
import FindFrameSplit_Popup from '../popup/FindFrameSplit_Popup';
import FindFrameGap_Popup from '../popup/FindFrameGap_Popup';
import AdjustFrameGap_Popup from '../popup/AdjustFrameGap_Popup';
import FindFrameCPS_Popup from '../popup/FindFrameCPS_Popup';
import MultipleFindReplaceDialog_Popup from '../popup/MultipleFindReplaceDialog_Popup';

const PopupGroupList = ({ _WaveformView }) => {
  return (
    <div>
      {/*右上角 總導覽工具*/}
      <Popup
        open={_WaveformView.state.isShowTranslationsNavbarAlert}
        modal
        closeOnDocumentClick
        onClose={() => {
          _WaveformView.setState({ isShowTranslationsNavbarAlert: false });
        }}
        contentStyle={{
          width: '200px',
          position: 'absolute',
          right: '10px',
          top: '50px',
        }}
      >
        <SubtitleContext.Consumer>
          {(context) => (
            <TranslationsNavbar
              ref={(ref) => (_WaveformView.TranslationsNavbar = ref)}
              context={context}
              closeTranslationsNavbarAlertView={() => {
                _WaveformView.isShowTranslationsNavbarAlert(false);
              }}
              setFontSize={(size) => {
                let CaptionContainer =
                  document.getElementById('CaptionContainer');
                if (size === 100) {
                  //回復原來的style 大小
                  _WaveformView.CaptionContainerFontSize =
                    _WaveformView.StyleData.fFontSize;
                  CaptionContainer.style.fontSize = `${_WaveformView.CaptionContainerFontSize}pt`;
                } else {
                  _WaveformView.CaptionContainerFontSize =
                    _WaveformView.StyleData.fFontSize * 1.5;
                  CaptionContainer.style.fontSize = `${_WaveformView.CaptionContainerFontSize}pt`;
                }
              }}
              data={_WaveformView.state.data}
              collapsed={_WaveformView.state.collapsed}
              findFrameSplitValue={_WaveformView.findFrameSplitValue}
              videoFps={TimeUtils.getFPS()}
              projectData={_WaveformView.projectData}
              projectDetial={_WaveformView.projectDetial}
              //刷新資料
              reflashTable={() => {
                _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
              }}
              updateEditTableData={(newData) => {
                _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  newData
                );
              }}
              updateEditTableData_frome_import={(newData) => {
                _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  newData
                );
              }}
              setDoubleClick={(newIndex) => {
                //往下呼叫
                //灰框點擊兩下
                DragHandleUtils.setDoubleClick(_WaveformView, newIndex);
              }}
              openTimecodeShiftView={async () => {
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({ isShowTimecodeShiftView: true });
              }}
              //檢查錯誤
              WaveformObjView_checkFrameSplitErrorArray={() => {
                _WaveformView.checkFrameSplitErrorArray();
              }}
              openRunZerotimeView={async () => {
                //開Zerotime 關閉導覽視窗
                _WaveformView.setState({
                  isShowRunZerotime: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              //frame錯誤
              frameSplitError={async () => {
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowFrameSplitError: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              //shotChange檢查
              shotChangeError={async () => {
                //開始搜尋
                const newDataContent = _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );

                //更新資料
                newDataContent.map((orgData, index) => {
                  _WaveformView.DataObjArray.updateDataObj_by_index(
                    index,
                    orgData
                  );
                });

                //顯示列表
                await _WaveformView.setState({ isShowShotChangeList: true });

                // 關閉 Frame Gap Error
                await _WaveformView.setState({ isShowFindFrameGapList: false });

                //顯示編輯區
                await _WaveformView.props.show_hide_Shot_Change(
                  _WaveformView.props.editTable.columns,
                  true,
                  _WaveformView.props.editTable
                );

                await _WaveformView.props.setTableColWidth(
                  window.innerWidth -
                    _WaveformView.props.viewOperation.subtitles_Left -
                    100,
                  2,
                  _WaveformView.props.editTable
                );

                await _WaveformView.setState({
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              //間距檢查
              frameGapError={async () => {
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowFrameGapError: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              adjustFrameGapError={async () => {
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowAdjustFrameGapError: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              //CPS檢查
              frameCPSError={async () => {
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowFrameCPSError: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              promptGoToLine={() => {
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <div className='custom-ui'>
                        <Form>
                          <Form.Field>
                            <label>Please type line number</label>
                            <input
                              autoFocus
                              placeholder='Please type line number'
                              onChange={(event) => {
                                // if(isNaN(parseFloat(event.target.value)) === false){
                                //
                                //
                                // }
                                _WaveformView.lineNum = event.target.value;
                              }}
                            />
                          </Form.Field>
                          <Button
                            type='button'
                            color='blue'
                            onClick={() => {
                              //更新cell選擇
                              let getRow = parseInt(
                                parseFloat(_WaveformView.lineNum) - 1,
                                10
                              );
                              //灰框點擊兩下
                              DragHandleUtils.setDoubleClick(
                                _WaveformView,
                                getRow
                              );

                              _WaveformView.isShowTranslationsNavbarAlert(
                                false
                              );

                              onClose();
                            }}
                          >
                            Submit
                          </Button>
                          <Button
                            type='button'
                            basic={true}
                            onClick={() => {
                              _WaveformView.isShowTranslationsNavbarAlert(
                                false
                              );
                              onClose();
                            }}
                          >
                            Cancel
                          </Button>
                        </Form>
                      </div>
                    );
                  },
                });
              }}
              openTimeLineAlert={async () => {
                _WaveformView.setState({
                  isShowTimeLineAlert: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              findAll={async () => {
                //await _WaveformView.setState({loading:true});
                //更新資料
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowFindAllViewInput: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              findAllReplace={async () => {
                await _WaveformView.setState({ loading: true });
                //更新資料
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowFindAllViewReplace: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              // 多重取代
              multipleFindReplace={async () => {
                await _WaveformView.setState({ loading: true });
                //更新資料
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowMultipleFindReplace: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              //尋找有對齊的文字
              findPositionAndAlign={async () => {
                await _WaveformView.setState({ loading: true });
                //更新資料
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isPositionAlignDialog: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              //開啟style檢查
              sendRunTargetCheck={async () => {
                /**
                 * 進行Style檢察
                 * */
                _WaveformView.tableRunTargetCheck();

                _WaveformView.setState({
                  isShowExportErrorList: true,
                  isShowTranslationsNavbarAlert: false,
                });
              }}
              //顯示版本介面
              showVersions={async () => {
                await _WaveformView.setState({ loading: true });
                //更新資料
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
                _WaveformView.setState({
                  isShowVersionsView: true,
                  isShowTranslationsNavbarAlert: false,
                  loading: false,
                });
              }}
              //修正FrameSplit錯誤 使用style 裡面的 this.StyleData.fFrameSplit
              runAdjustFrameSplit={async () => {
                await _WaveformView.setState({ isShowFindFrameList: false });

                await _WaveformView.setState({ loading: true });
                await _WaveformView.setState({
                  loading: false,
                  isShowTranslationsNavbarAlert: false,
                });

                let stringData = _WaveformView.DataObjArray.getContent();
                stringData.map((request, index) => {
                  //工作的
                  let dataObj = new DataObj(request); //當前物件
                  dataObj.setTSubType(WaveformView.projectSubType);

                  //如果不是空的才做調整
                  //檢查結束時間跟下一個的開始時間的距離
                  if (index !== stringData.length - 1) {
                    let dataObj_next = stringData[index + 1]; //下一個物件
 
                    const _frameCheckValue = parseFloat(
                      _WaveformView.StyleData.fFrameSplit
                    );

                    const isError = FrameUtils.isDataObjGetFrameSplit(dataObj, dataObj_next,
                      _frameCheckValue 
                    );

                    if (isError) {
                      // 如果有錯誤的話，進行處理
                      const newDataObjOut =
                        TimeUtils.getTimeString_byframeSplitError(
                          dataObj_next.In,
                          parseFloat(_frameCheckValue),
                          TimeUtils.getFPS()
                        );

                      dataObj.setInOut('Out', newDataObjOut, dataObj.Out);

                      stringData[index] = dataObj;

                      _WaveformView.DataObjArray.updateDataObj_by_index(
                        index,
                        dataObj
                      );
                      _WaveformView.UpdateSpecificGraySquare_Size(index);
                    }

                    // if (In_next !== "" && Out !== "") {
                    //   const Out_frame = parseFloat(
                    //     parseFloat(
                    //       TimeUtils.timeString_convertTo_frame(Out)
                    //     ).toFixed(2)
                    //   );
                    //   const In_next_frame = parseFloat(
                    //     parseFloat(
                    //       TimeUtils.timeString_convertTo_frame(In_next)
                    //     ).toFixed(2)
                    //   );

                    //   const frameDistance = parseFloat(
                    //     parseFloat(In_next_frame - Out_frame).toFixed(2)
                    //   );

                    //   //如果尾巴更多於下一個的起始
                    //   if (
                    //     parseFloat(frameDistance) <
                    //       parseFloat(_frameCheckValue) ||
                    //     parseFloat(Out_frame) >= parseFloat(In_next_frame)
                    //   ) {
                    //     const newDataObjOut =
                    //       TimeUtils.getTimeString_byframeSplitError(
                    //         In_next,
                    //         parseFloat(_frameCheckValue),
                    //         TimeUtils.getFPS()
                    //       );
                    //     dataObj.setInOut("Out", newDataObjOut, dataObj.Out);

                    //     stringData[index] = dataObj;

                    //     _WaveformView.DataObjArray.updateDataObj_by_index(
                    //       index,
                    //       dataObj
                    //     );

                    //     _WaveformView.UpdateSpecificGraySquare_Size(index);
                    //   }
                    // }
                  }
                });
                //初始字幕跟拖拉資料
                _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  stringData
                );
                _WaveformView.setIsEdit(true);
              }}
              //修正FrameGapError錯誤
              runAdjustFrameGapError={async (startGap, endGap) => {
                await _WaveformView.setState({ isShowFindFrameGapList: false });

                await _WaveformView.setState({ loading: true });
                await _WaveformView.setState({
                  loading: false,
                  isShowTranslationsNavbarAlert: false,
                });

                let stringData = _WaveformView.DataObjArray.getContent();

                let newTarget = [];
                stringData.forEach(function (qdata, index) {
                  let ROWoBJ = new DataObj(qdata);
                  ROWoBJ.setTSubType(WaveformView.projectSubType);

                  // 只有最後一個沒有間距
                  if (index !== stringData.length - 1) {
                    //當下資料
                    const currentIn = ROWoBJ.In;
                    const currentOut = ROWoBJ.Out;

                    //下一個
                    const nextROWoBJ = new DataObj(stringData[index + 1]);
                    nextROWoBJ.setTSubType(WaveformView.projectSubType);
                    const nextIn = nextROWoBJ.In;

                    //當下frame
                    const beginFrameNumber =
                      TimeUtils.timeString_convertTo_frame(currentIn);
                    const currentFrame =
                      TimeUtils.timeString_convertTo_frame(currentOut);

                    //下一個frame
                    const nextFrame =
                      TimeUtils.timeString_convertTo_frame(nextIn);

                    //計算
                    const countFrameNumber =
                      parseFloat(nextFrame) - parseFloat(currentFrame);

                    //get frame number
                    let durationFrame =
                      parseFloat(currentFrame) - parseFloat(beginFrameNumber);

                    //console.log(`durationFrame  ${currentFrame} - ${beginFrameNumber} = ${durationFrame}  `);

                    if (
                      parseFloat(currentFrame) === 0 ||
                      parseFloat(beginFrameNumber) === 0
                    ) {
                      return;
                    }

                    if (nextROWoBJ.In === '') {
                      return;
                    }

                    if (
                      !MathUtils.checkFrameGapIsError(
                        countFrameNumber,
                        startGap,
                        endGap
                      )
                    ) {
                      //沒錯 => 過關
                    } else {
                      //新
                      ROWoBJ.setInOut(
                        'Out',
                        TimeUtils.getTimeString_byframeSplitError(
                          nextIn,
                          2,
                          TimeUtils.getFPS()
                        )
                      );

                      stringData[index] = ROWoBJ;

                      _WaveformView.DataObjArray.updateDataObj_by_index(
                        index,
                        ROWoBJ
                      );

                      _WaveformView.UpdateSpecificGraySquare_Size(index);
                    }
                  }
                });

                //初始字幕跟拖拉資料
                _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  stringData
                );

                _WaveformView.setIsEdit(true);
              }}
              //輸入畫面
              openImportView={() => {
                _WaveformView.setState({ isShowImportView: true });
              }}
              //輸出畫面
              openExportView={() => {
                //進行檢查
                /**
                 * 進行Style檢察
                 * */
                _WaveformView.tableRunTargetCheck();

                _WaveformView.setState({ isShowExportView: true });
                // _WaveformView.setState({ isShowExportErrorList: true });
              }}
              sendComplete={async () => {
                await _WaveformView.setState({
                  isShowTranslationsNavbarAlert: false,
                });
                await _WaveformView.setState({ loading: true });

                //再檢查一次style
                _WaveformView.tableRunTargetCheck();

                //檢查有沒有不對稱的In Out
                const checkArray =
                  _WaveformView.DataObjArray.IncompleteInspection();
                if (checkArray.length > 0) {
                  alert('Please check row ' + checkArray.toString());
                }

                const FindFrameTargetData =
                  _WaveformView.props.updateFindFrameTargetData(
                    _WaveformView.DataObjArray.getContent(),
                    TimeUtils.getFPS(),
                    _WaveformView.findFrameSplitValue
                  );
                //
                await _WaveformView.setState({ loading: false });

                //開始搜尋
                let message = '';

                if (FindFrameTargetData.length !== 0) {
                  message = 'Need check Frame Split';
                }

                await _WaveformView.setState({ message: message });

                await _WaveformView.setState({ isShowComplete: true });
              }}
              senddeleteSource={() => {
                confirmAlert({
                  title: 'WARNING',
                  message: 'Delete Source',
                  buttons: [
                    {
                      label: 'Ok',
                      onClick: () => _WaveformView.send_deleteSource(),
                    },
                    {
                      label: 'Cancel',
                    },
                  ],
                });
                _WaveformView.isShowTranslationsNavbarAlert(false);
              }}
              sendCopyToSource={() => {
                confirmAlert({
                  title: 'WARNING',
                  message:
                    'The texts in Target column will be copied to Source column.\n' +
                    'This action is NOT reversible',
                  buttons: [
                    {
                      label: 'Proceed',
                      onClick: async () => {
                        _WaveformView.DataObjArray.copyToSource();

                        _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                          _WaveformView.DataObjArray.getContent()
                        );

                        const { user } = _WaveformView.props.auth;
                        const email = user['email'];
                        //儲存
                        await _WaveformView.props.AddDetialJsonData({
                          tProjectDetialId: _WaveformView.projectDetial.fId,
                          jsonstring: _WaveformView.DataObjArray.getContent(),
                          email: email,
                        });
                      },
                    },
                    {
                      label: 'Cancel',
                    },
                  ],
                });
                _WaveformView.isShowTranslationsNavbarAlert(false);
              }}
            />
          )}
        </SubtitleContext.Consumer>
      </Popup>

      {/*輸入畫面*/}
      {/* <ImportView_Popup _WaveformView={_WaveformView} /> */}

      {/*輸出畫面*/}
      <ExportView_Popup _WaveformView={_WaveformView} /> 
      

      {/*完成提式*/}
      <Complete_Popup _WaveformView={_WaveformView} />

      {/*開啟 Timecode shift 設定*/}
      <TimecodeShiftView_Popup _WaveformView={_WaveformView} />

      {/*開啟 Zerotime 設定*/}
      <RunZerotime_Popup _WaveformView={_WaveformView} />

      {/*開啟版本控制*/}
      <VersionsView_Popup _WaveformView={_WaveformView} />

      {/*玩家選擇 TimeLine Alert*/}
      <ShowTimeLineAlert_Popup _WaveformView={_WaveformView} />

      {/*尋找位置*/}
      <PositionAlignDialog_Popup _WaveformView={_WaveformView} />

      {/*尋找位置*/}
      <MultipleFindReplaceDialog_Popup _WaveformView={_WaveformView} />

      {/*找出Frame錯誤*/}
      <FindFrameSplit_Popup _WaveformView={_WaveformView} />

      {/*找出Frame Gap錯誤*/}
      <FindFrameGap_Popup _WaveformView={_WaveformView} />

      <AdjustFrameGap_Popup _WaveformView={_WaveformView} />

      {/*找出Frame CPS錯誤*/}
      <FindFrameCPS_Popup _WaveformView={_WaveformView} />
    </div>
  );
};

export default PopupGroupList;



// WEBPACK FOOTER //
// ./src/components/drogable/PopupGroupList.js